// extracted by mini-css-extract-plugin
export default {"myprofile":"myprofile_myprofile__xRRTa","promenu":"myprofile_promenu__pPhQe","probody":"myprofile_probody__3dwBr"};